var map = {
	"./accident.svg": "9c8a",
	"./aib.svg": "2361",
	"./burglary.svg": "52d6",
	"./coastal.svg": "326c",
	"./crime.svg": "7311",
	"./fire.svg": "62e5",
	"./flood.svg": "8fd1",
	"./other.svg": "4e6e",
	"./perilfinder.svg": "41cb",
	"./river.svg": "ede8",
	"./s-circle.svg": "fd35",
	"./s-polygon.svg": "8995",
	"./s-square.svg": "c428",
	"./search-grey.svg": "9d9a",
	"./search.svg": "d103",
	"./select-add.svg": "5540",
	"./select-circle.svg": "3a24",
	"./select-clear.svg": "2e2d",
	"./select-click.svg": "3b35",
	"./select-remove.svg": "87e8",
	"./select-square.svg": "4a75",
	"./storm.svg": "dd68",
	"./subsidence.svg": "b6a3",
	"./surfaceWater.svg": "4c37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";